module.exports = __webpack_public_path__ + "pc/img/logo-2.ca40c7d6.png";